import axios from 'axios';
import { nanoid } from 'nanoid';
import { PortfolioItemResponse, PortfolioItemTreeNode } from 'types/portfolios';
import { ValidationResult } from 'types/validation';

export const fetchPortfolioItems = async (): Promise<PortfolioItemResponse[]> => {
    const response = await axios.get('/portfolios/items');
    return response.data;
};

export const createPortfolioItemTree = (
    items: PortfolioItemResponse[],
    typeIdFilter: number[] = []
): PortfolioItemTreeNode[] => {
    const filtered = typeIdFilter.length > 0 ? items.filter((item) => typeIdFilter.includes(item.typeId)) : items;

    const result = filtered?.map((response) => {
        const rtn: PortfolioItemTreeNode = {
            id: nanoid(12),
            label: response.itemTypeLabelName,
            isFolder: false,
            path: '',
            properties: {
                itemTypeLabelName: response.itemTypeLabelName,
                typeGroupName: response.typeGroupName,
                typeName: response.typeName,
                subSchemaId: response.subSchemaId,
                typeGroupId: response.typeGroupId,
                typeId: response.typeId,
                name: response.itemTypeLabelName,
            },
            nodes: response.items?.map((item) => ({
                id: String(item.id),
                label: item.name,
                isFolder: false,
                path: '',
                nodes: [],
                isSelected: false,
                isDisabled: false,
                properties: {
                    id: item.id,
                    name: item.name,
                    ownershipPercentage: item.ownershipPercentage,
                    securityId: item.securityId,
                    latitude: item?.latitude,
                    longitude: item?.longitude,
                    objectId: item?.objectId,
                    typeId: response.typeId,
                    isMaster: item.securityId,
                    itemType: response.itemTypeLabelName,
                },
            })),
        };
        return rtn;
    });

    return result;
};

export const validateForwardCurveConstraints = async (payload: {
    forwardCurveIds: number[];
    forwardCurveConstraintIds: number[];
}): Promise<ValidationResult | null> => {
    const result = await axios.post<ValidationResult>('/portfolios/forward-curves-constraints-validation', payload);
    return result.data;
};

export const validateHydro = async (payload: {
    hydroIds: number[];
    hydroProjectIds: number[];
}): Promise<ValidationResult | null> => {
    const result = await axios.post<ValidationResult>('/portfolios/hydro-project-validation', payload);
    return result.data;
};

export const validateGlobalShapes = async (
    mainMarketModelId: number,
    payload: { itemIds: number[] }
): Promise<ValidationResult | null> => {
    const result = await axios.post<ValidationResult>(
        `/portfolios/global-shapes-validation/${mainMarketModelId}`,
        payload.itemIds
    );
    return result.data;
};

export const createPortfolioAssignItems = async (payload: any): Promise<any> => {
    const result = await axios.post('/portfolios/create-portfolio-assign-items', payload);
    return result.data;
};

export const validateMarketModelRequiredForwards = async (mainMarketModelId: number) => {
    const result = await axios.get<ValidationResult>(
        `/portfolios/${mainMarketModelId}/validate-market-model-required-forwards`
    );
    return result.data;
};
